"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStreemLogger = exports.setStreemLogger = exports.streemLogger = void 0;
const TempLogger = {
    extend: () => TempLogger,
    setContextValue: () => { },
    removeContextValue: () => { },
    trace: (...args) => {
        console.warn('[sdk-chime-video] logger called before configureChimeVideo()');
        console.trace(...args);
    },
    isTrace: () => true,
    debug: (...args) => {
        console.warn('[sdk-chime-video] logger called before configureChimeVideo()');
        console.debug(...args);
    },
    isDebug: () => true,
    info: (...args) => {
        console.warn('[sdk-chime-video] logger called before configureChimeVideo()');
        console.info(...args);
    },
    isInfo: () => true,
    warn: (...args) => {
        console.warn('[sdk-chime-video] logger called before configureChimeVideo()');
        console.warn(...args);
    },
    isWarn: () => true,
    error: (...args) => {
        console.warn('[sdk-chime-video] logger called before configureChimeVideo()');
        console.error(...args);
    },
    isError: () => true,
};
exports.streemLogger = TempLogger;
function setStreemLogger(nextLogger) {
    exports.streemLogger = nextLogger;
}
exports.setStreemLogger = setStreemLogger;
function createStreemLogger(context) {
    if (typeof context === 'undefined') {
        return exports.streemLogger;
    }
    return exports.streemLogger.extend(context);
}
exports.createStreemLogger = createStreemLogger;
//# sourceMappingURL=streem_logger.js.map